export const normalizeApiUrl = (url) => {
  if (!url) return url
  const trimmed = url.replace(/\/+$/, '')
  if (trimmed.endsWith('/api')) return trimmed
  return `${trimmed}/api`
}

export const isLocalAdminDevHost = (hostname = '') =>
  ['localhost', '127.0.0.1'].includes(String(hostname).trim().toLowerCase())

export const isProductionLikeAdminEnv = (env = process.env) =>
  ['production', 'prod'].includes(
    String(env.REACT_APP_APP_ENV || env.APP_ENV || env.NODE_ENV || '')
      .trim()
      .toLowerCase(),
  )

export const isLocalApiProxyEnabled = () =>
  !isProductionLikeAdminEnv() &&
  !['0', 'false', 'no', 'off'].includes(
    String(process.env.REACT_APP_USE_LOCAL_API_PROXY || '')
      .trim()
      .toLowerCase(),
  )

export const shouldUseLocalApiProxy = (
  locationLike = typeof window !== 'undefined' ? window.location : null,
) => Boolean(locationLike && isLocalAdminDevHost(locationLike.hostname) && isLocalApiProxyEnabled())

export const resolveApiUrl = (
  url,
  locationLike = typeof window !== 'undefined' ? window.location : null,
) => {
  if (shouldUseLocalApiProxy(locationLike)) {
    return '/api'
  }

  return normalizeApiUrl(url)
}

const configuredApiUrl =
  process.env.REACT_APP_BASE_URL || process.env.BASE_URL || 'https://stagingapi.onebodyapp.com/api'
const configuredTestUrl =
  process.env.REACT_APP_BASE_URL_TEST ||
  process.env.BASE_URL_TEST ||
  'https://stagingapi.onebodyapp.com/api'

const defaultApiUrl = resolveApiUrl(configuredApiUrl)
const defaultTestUrl = resolveApiUrl(configuredTestUrl)

const Constants = {
  API_URL: defaultApiUrl,
  API_URL_TEST: defaultTestUrl,
}

export default Constants
